<div class="flex-row submission-closed">
  <h1 class="mat-headline-4">
    The {{ today | date: 'yyyy' }} data submission period is closed for any data
    submissions! Accepted data and previous year data submissions are available
    to view in the <a [routerLink]="['/table-archive']">Table Archive</a>.
  </h1>
</div>
